import { Grid, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import React from "react"
import { ChevronDown } from "react-feather"
import TrocaLaboratorio from "../../features/login/views/TrocaLaboratorio";
import { TEXT_SECONDARY_COLOR } from "../../theme";

const UserInfo = (props) => {
	const classes = useStyles()
	const informacoesLaboratorio = props.codigoLaboratorio ? `${props.codigoLaboratorio} - ${props.nomeLaboratorio}` : ""

	return (
		<>
			<Grid container alignItems="center" direction="row" justifyContent="space-between">
				<Grid container xs={12} item >
					<Grid item className={classes.wrap} xs>
						<Typography noWrap id="nomeUsuario" className={classes.nome}>
							{props.nome}
						</Typography>
						<Typography noWrap id="laboratorio" className={classes.laboratorio} title={informacoesLaboratorio}>
							{informacoesLaboratorio}
						</Typography>
					</Grid>
					<Grid item xs={3}>
						<TrocaLaboratorio
							icone={<ChevronDown size={24} color={TEXT_SECONDARY_COLOR} className={"pr-0"} />}
							referenciaAncora={props.referenciaAncora}
							usuario={props.usuario}
						/>
					</Grid>
				</Grid>
			</Grid>
		</>
	)
}

const useStyles = makeStyles({
	nome: {
		color: "#23144D",
		overflow: "hidden",
		fontSize: "16px",
		fontWeight: "bold",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		lineHeight: "20px",
	},
	laboratorio: {
		color: "#61688B",
		overflow: "hidden",
		fontSize: "14px",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		lineHeight: "18px",
	},
	outroLab: {
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
	},
	icon: {
		color: "#61688B",
	},
	wrap: {
		overflow: "hidden",
		paddingLeft: '8px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},
	botaoSair: {
		cursor: "pointer",
	},
})

export default UserInfo
